import { State } from "@store/types";

export function getParameters(state: State) {
  return state.insights_parameters;
}
